import sharedStyles from '@muiscss/sharedStyles.module.scss'
import clsx from 'clsx'
import { forwardRef } from 'react'
import styles from './styles.module.scss'
import { ITextareaProps } from './types'

const Textarea = forwardRef<HTMLTextAreaElement, ITextareaProps>(
  ({ label, hasError, error, size = 'md', transparent = false, resize = true, ...props }, ref) => {
    const { value, ...restProps } = props
    // remove after deprecated hasError is replaced with error
    const tempoVarError = error || hasError

    return (
      <div className={styles.innerHolder}>
        {label && (
          <label
            className={clsx('mui-input-label', sharedStyles.label, sharedStyles[size], {
              [sharedStyles.disabled]: props.disabled,
            })}
            data-testid="mui-label"
            htmlFor={props.id || 'mui-textarea'}
          >
            {label} {props.required && '*'}
          </label>
        )}
        <div className={clsx(styles.wrap)}>
          <textarea
            className={clsx('mui-textarea', styles.textarea, styles[size], {
              [sharedStyles.inputError]: tempoVarError,
              [styles.transparent]: transparent,
              [styles.resize]: resize,
            })}
            defaultValue={value}
            id={props.id || 'mui-textarea'}
            ref={ref}
            {...restProps}
          />
          {typeof error === 'string' && <span className={styles.errorMessage}>{error}</span>}
        </div>
      </div>
    )
  },
)

export default Textarea
